import React from 'react';
import {
    Box, HStack, Heading, Icon, IconButton,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody,
    useDisclosure,
} from '@chakra-ui/react';
import { FaExpand } from 'react-icons/fa';

const ExpandableChartCard = ({ title, icon, children, height = '320px', headerRight = null, footer = null }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const header = (size, headingSize) => (
        <HStack spacing={2} justify="space-between" align="center" w="100%">
            <HStack spacing={2} minW={0}>
                {icon && <Icon as={icon} color="#F68633" boxSize={size} />}
                <Heading size={headingSize} color="gray.700" noOfLines={1}>{title}</Heading>
            </HStack>
            <HStack spacing={1} flexShrink={0}>
                {headerRight}
                {size === 4 && (
                    <IconButton
                        aria-label="Tela cheia"
                        icon={<FaExpand />}
                        size="xs"
                        variant="ghost"
                        colorScheme="orange"
                        onClick={onOpen}
                    />
                )}
            </HStack>
        </HStack>
    );

    return (
        <>
            <Box bg="white" p={{ base: 3, md: 4 }} borderRadius="lg" boxShadow="sm" borderWidth="1px" borderColor="gray.200">
                <Box mb={3}>{header(4, 'sm')}</Box>
                <Box h={height}>{children}</Box>
                {footer}
            </Box>

            <Modal isOpen={isOpen} onClose={onClose} size={{ base: 'full', md: '6xl' }} isCentered scrollBehavior="inside">
                <ModalOverlay />
                <ModalContent mx={{ base: 0, md: 4 }} my={{ base: 0, md: 4 }}>
                    <ModalHeader pr={12}>{header(5, 'md')}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <Box h={{ base: '72vh', md: '76vh' }} w="100%">{children}</Box>
                        {footer && <Box mt={2}>{footer}</Box>}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};

export default ExpandableChartCard;
